import React from 'react';
import { Text, View } from 'react-native';
import { DOCUMENTS_UNOPENED_BADGE_MAX } from '../constants';
import { useUnopenedReports } from '../hooks/useUnopenedReports';
import type { TDocumentsTabBarIconProps } from '../types';
import { DocumentsTabBarIcon } from './icons';

export const DocumentsTabIcon = ({ color, size, focused }: TDocumentsTabBarIconProps) => {
    const { count: unopenedCount } = useUnopenedReports();

    return (
        <View>
            <DocumentsTabBarIcon focused={focused} size={size} color={color} />
            {unopenedCount > 0 && (
                <View className="absolute -right-[17px] -top-[8px] h-[24px] w-[34px] items-center justify-center rounded-full border-2 border-white bg-secondary-600">
                    <Text className="text-sm font-bold leading-[16px] text-white">
                        {unopenedCount > DOCUMENTS_UNOPENED_BADGE_MAX ? `${DOCUMENTS_UNOPENED_BADGE_MAX}+` : unopenedCount}
                    </Text>
                </View>
            )}
        </View>
    );
};
